import { isString, isNumeric } from "@payair/e-com-common-sdk/core/Validators";
import { validateApplePayLineItemType } from "./ApplePayLineItemType";
import { validateApplePayPaymentTiming } from "./ApplePayPaymentTiming";
import { validateApplePayRecurringPaymentDateUnit, } from "./ApplePayRecurringPaymentDateUnit";
/** @internal */
export var validateApplePayLineItem = function (applePayLineItem) {
    var errorMessage = [];
    if (!applePayLineItem.label)
        errorMessage.push("label not defined");
    else if (!isString(applePayLineItem.label))
        errorMessage.push("label is not a string");
    if (!applePayLineItem.amount)
        errorMessage.push("amount not defined");
    else if (!isNumeric(applePayLineItem.amount) ||
        parseFloat(applePayLineItem.amount) <= 0 ||
        !new RegExp("^[0-9]+(\\.[0-9][0-9])$").test(applePayLineItem.amount))
        errorMessage.push("amount is not a valid number: ".concat(applePayLineItem.amount));
    if (applePayLineItem.paymentTiming)
        !validateApplePayPaymentTiming(applePayLineItem.paymentTiming) &&
            errorMessage.push("paymentTiming is not a valid object of ApplePayPaymentTiming type");
    if (applePayLineItem.type)
        !validateApplePayLineItemType(applePayLineItem.type) &&
            errorMessage.push("type is not a valid object of ApplePayLineItemType");
    if (applePayLineItem.recurringPaymentIntervalUnit)
        !validateApplePayRecurringPaymentDateUnit(applePayLineItem.recurringPaymentIntervalUnit) &&
            errorMessage.push("recurringPaymentIntervalUnit is not a valid object of ApplePayRecurringPaymentDateUnit type");
    return errorMessage;
};
